export const CloseIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
			<rect width="50" height="50" rx="15" fill="#262A2F" />
			<path d="M18.6357 18.6361L31.3637 31.364" stroke="#F6F6F6" strokeWidth="2" />
			<path d="M31.3643 18.6361L18.6363 31.364" stroke="#F6F6F6" strokeWidth="2" />
		</svg>
	)
}
